module.exports = __webpack_public_path__ + "static/assets/77198c2a5896b4c1d247e9b8d2c04b5f.svg";